// All Routes of the Application are declared here
export const ROOT = "/"
export const LOGIN = "/login"
export const BOOKING_HISTORY = "/booking-history"
export const BOOKING_HISTORY_DETAILS = `${BOOKING_HISTORY}/details/:bookingId`
export const USERS = `/users`
export const USER_PROFILE = `${USERS}/:userId/profile`
export const USER_BOOKING_DETAILS = `${USERS}/:userId/booking-history`
export const USER_BOOKING_DETAILS_BY_ID = `${USERS}/:userId/booking-history/details/:bookingId`
export const USER_AUDIT_LOG = `${USERS}/:userId/audit-logs`
export const CENTERS = "/centers"
export const ADD_CENTER = `${CENTERS}/:centerId`
export const CENTER_DETAILS = `${CENTERS}/details/:centerId`
export const MEETING_ROOMS = "/meeting-rooms"
export const ADD_MEETING_ROOM = `${MEETING_ROOMS}/:id`
export const AUDIT_LOGS = `/audit-logs`
export const TRANSACTIONS = `/transactions`
export const CUSTOMERS = `/customers`
export const CUSTOMER_REPOSITORY = `/customer-repository`
export const TRANSACTIONS_UPLOAD_HISTORY = `${TRANSACTIONS}/upload-history`
export const BANK_ACCOUNTS = `/bank-accounts`
export const BANK_ACCOUNTS_VIEW = `/bank-accounts/:bankAccountId`
export const INVOICES = "/invoices"
export const CATEGORIES = `/categories`
export const CATEGORY_1 = `${CATEGORIES}/category1`
export const CATEGORY_2 = `${CATEGORIES}/category2`
export const CATEGORY_3 = `${CATEGORIES}/category3`
